module.exports = __webpack_public_path__ + "static/media/power-ranking-menu-icon.e3d13188.svg";